module.exports = __webpack_public_path__ + "media/images/core_values/environmentalism-91f9607785794db85af9e86ccf5fbe5c.png";